export const path = "/master-branding";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MASTER BRANDING",
  section: "ALUNA",
  group: null,
  order: 3,
  roles: [
    "Authenticated",
    "aluna",
    "aluna-management",
    "design",
    "aluna-branding",
    "master-aluna-rrss",
    "aluna-afiliado",
  ],
};
